import { MutationTree } from 'vuex'
import { MutationTypes } from './types'
import { State } from './state'

export type Mutations<S = State> = {
  [MutationTypes.TOGGLE_DIALOG](state: S, payload: boolean): void;
  [MutationTypes.SET_NOTIFICATION](state: S, payload: any): void;
}

export const mutations: MutationTree<State> & Mutations = {
  [MutationTypes.TOGGLE_DIALOG] (state, b) { state.dialog.active = b },
  [MutationTypes.SET_NOTIFICATION] (state, { type, message }) {
    state.error = {
      show: true,
      type,
      message
    }
  }
}
